var React = require('react');

function FlagId (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"flag/indonesia","clipPath":"url(#clip0_121_2722)","key":0},React.createElement("g",{"id":"Group"},[React.createElement("path",{"id":"Vector","fillRule":"evenodd","clipRule":"evenodd","d":"M0.5 0.5H17.8333V7.24375H0.5V0.5Z","fill":"#E70011","key":0}),React.createElement("path",{"id":"Vector_2","fillRule":"evenodd","clipRule":"evenodd","d":"M0.5 7H17.8333V13.5H0.5V7Z","fill":"white","key":1})])),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_121_2722"},React.createElement("rect",{"width":"17.3333","height":"13","fill":"white","transform":"translate(0.5 0.5)"})))]);
}

FlagId.defaultProps = {"width":"18","height":"14","viewBox":"0 0 18 14","fill":"none"};

module.exports = FlagId;

FlagId.default = FlagId;
